import type {SVGProps} from 'react'
const DeliveryDpdIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    width="1em"
    height="1em"
    overflow="visible"
    style={{
      display: 'block',
    }}
    viewBox="0 0 42 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 19819">
      <path
        id="path7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3808 14.5462C25.5381 14.7814 24.4406 14.8794 23.5 14.8794C21.0503 14.8794 19.4434 13.6055 19.4434 11.2734C19.4434 9.05891 20.9523 7.62831 23.1472 7.62831C23.6371 7.62831 24.1663 7.6871 24.4798 7.84388V4.62988H26.3808V14.5462ZM24.4798 9.49005C24.1859 9.35287 23.7743 9.27448 23.304 9.27448C22.1478 9.27448 21.3835 9.97999 21.3835 11.2146C21.3835 12.5277 22.2066 13.2724 23.5587 13.2724C23.7939 13.2724 24.1663 13.2724 24.4798 13.194V9.49005ZM42.0001 14.5462C41.1574 14.7814 40.0599 14.8794 39.0996 14.8794C36.6695 14.8794 35.0429 13.6055 35.0429 11.2734C35.0429 9.05891 36.5519 7.62831 38.7469 7.62831C39.2564 7.62831 39.7659 7.6871 40.0795 7.84388V4.62988H42.0001V14.5462ZM40.0795 9.49005C39.7855 9.35287 39.3936 9.27448 38.9232 9.27448C37.7474 9.27448 36.9831 9.97999 36.9831 11.2146C36.9831 12.5277 37.8258 13.2724 39.178 13.2724C39.4132 13.2724 39.7659 13.2724 40.0795 13.194V9.49005ZM29.3792 9.49005C29.6928 9.35287 30.1435 9.31367 30.5159 9.31367C31.6917 9.31367 32.4952 9.97999 32.4952 11.1754C32.4952 12.5864 31.5937 13.2332 30.3983 13.2528V14.8794H30.4963C32.9656 14.8794 34.4354 13.5271 34.4354 11.1167C34.4354 8.92172 32.8676 7.62831 30.5551 7.62831C29.3792 7.62831 28.223 7.90268 27.4587 8.21621V17.525H29.3792V9.49005Z"
        fill="var(--fill-0, #3F3F42)"
      />
      <path
        id="path9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3047 4.14844H16.3248H16.3047Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path11"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.834 3.89941L16.1475 4.25217L16.3239 4.15418L15.834 3.89941V3.89941Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path13"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3643 3.64648L15.9718 4.352L16.1873 4.23441L15.9522 3.96005L15.3643 3.64648V3.64648Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path15"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.874 3.38965L15.7951 4.44792L16.0107 4.33033L15.4815 3.70321L14.874 3.38965V3.38965Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path17"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4041 3.13577L15.6191 4.54679L15.8347 4.42921L14.992 3.44933L14.4041 3.13577ZM16.7362 5.62463L16.599 5.70302L16.7362 5.8598V5.62463V5.62463Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path19"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9336 2.875L15.4426 4.63878L15.6582 4.5212L14.5215 3.18856L13.9336 2.875V2.875ZM16.6576 5.65783L16.4421 5.79501L16.736 6.14777V5.77541L16.6576 5.65783H16.6576Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4434 2.62598L15.2659 4.74251L15.5011 4.62493L14.0509 2.93954L13.4434 2.62598V2.62598ZM16.481 5.76156L16.2654 5.89874L16.7357 6.44748V6.07512L16.481 5.76156Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path23"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9736 2.37305L15.1098 4.84233L15.3253 4.72475L13.5616 2.6866L12.9736 2.37305V2.37305ZM16.3052 5.88098L16.0896 5.99856L16.7363 6.76287V6.39051L16.3052 5.88098Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5032 2.11617L14.9333 4.93821L15.1488 4.82062L13.0911 2.42973L12.5032 2.11617V2.11617ZM16.1287 5.97685L15.9131 6.09444L16.7362 7.05472V6.68237L16.1287 5.97685Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path27"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0137 1.8623L14.7573 5.0371L14.9729 4.91951L12.6212 2.17586L12.0137 1.8623V1.8623ZM15.9527 6.07574L15.7372 6.19333L16.7366 7.34958V6.97723L15.9527 6.07574V6.07574Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path29"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.543 1.60254L14.5806 5.14969L14.7961 5.0125L12.1309 1.9161L11.543 1.60254V1.60254ZM15.776 6.16873L15.5604 6.28632L16.7363 7.65815V7.2858L15.776 6.16873Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path31"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0527 1.35352L14.4039 5.25342L14.6195 5.11623L11.6603 1.66707L11.0527 1.35352ZM15.6189 6.27246L15.3838 6.39005L16.736 7.95785V7.5855L15.6189 6.27246V6.27246Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path33"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.583 1.0957L14.2281 5.34833L14.4633 5.21117L11.1905 1.40926L10.583 1.0957ZM15.4432 6.3674L15.2276 6.48499L16.7366 8.26837V7.87642L15.4432 6.3674V6.3674Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path35"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1124 0.842856L14.0711 5.44824L14.2866 5.31105L10.7003 1.15641L10.1124 0.842856V0.842856ZM15.2665 6.46731L15.0509 6.5849L16.7363 8.56425V8.1919L15.2665 6.46731V6.46731Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path37"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62207 0.568359L13.8943 5.5461L14.1099 5.40891L10.2296 0.901515L9.62207 0.568359ZM15.0898 6.56517L14.8742 6.68275L16.7359 8.85806V8.48573L15.0898 6.56517V6.56517Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path39"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.15216 0.314527L13.7184 5.64501L13.9339 5.52743L9.75969 0.647683L9.15216 0.314527ZM14.9138 6.66409L14.6982 6.78167L16.7364 9.17255V8.78062L14.9138 6.66409V6.66409Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path41"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.68164 0.0800781L13.5418 5.74372L13.7574 5.62614L9.26954 0.393637L8.68164 0.0800781ZM14.7372 6.7628L14.5217 6.88038L16.7362 9.46724V9.09488L14.7372 6.7628V6.7628Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path43"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36822 0L13.3655 5.84002L13.5811 5.72244L8.79937 0.137182L8.68178 0.0783897C8.5838 0.0195974 8.48581 0 8.36822 0ZM14.561 6.8591L14.3454 6.97668L16.7363 9.75951V9.38716L14.561 6.8591V6.8591Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path45"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36821 0C8.28982 0 8.21143 0.0195974 8.13304 0.0391949L13.1892 5.93801L13.4243 5.82043L8.427 0C8.4074 0 8.38781 0 8.36821 0ZM14.4042 6.95708L14.1886 7.07467L16.7363 10.0731V9.68112L14.4042 6.95708V6.95708Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path47"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.1922 0.0175781C8.15301 0.0371756 8.09421 0.0567729 8.07462 0.0763705L7.95703 0.135163L13.0327 6.03398L13.2483 5.91639L8.1922 0.0175781V0.0175781ZM14.2282 7.05305L14.0126 7.19024L16.7367 10.365V9.99266L14.2282 7.05305V7.05305Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path49"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99585 0.0976562L7.78027 0.215241L12.856 6.13366L13.0716 6.01607L7.99585 0.0976562V0.0976562ZM14.0514 7.15273L13.8359 7.28991L16.7363 10.6607V10.2883L14.0514 7.15273V7.15273Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path51"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.81909 0.195312L7.60352 0.312897L12.6792 6.23131L12.8948 6.11373L7.81909 0.195312V0.195312ZM13.8747 7.25039L13.6591 7.38757L16.7359 10.9739V10.6015L13.8747 7.25039Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path53"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.64331 0.292969L7.42773 0.410554L12.5035 6.32897L12.719 6.21138L7.64331 0.292969V0.292969ZM13.6989 7.34804L13.4833 7.48523L16.7365 11.2675V10.8952L13.6989 7.34804Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46655 0.390625L7.25098 0.50821L12.3267 6.42663L12.5423 6.30904L7.46655 0.390625V0.390625ZM13.5221 7.4457L13.3066 7.58288L16.7361 11.5612V11.1888L13.5221 7.4457V7.4457Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path57"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28979 0.480469L7.07422 0.598052L12.15 6.51647L12.3655 6.39888L7.28979 0.480469V0.480469ZM13.365 7.53554L13.1494 7.67273L16.7357 11.8666V11.4942L13.365 7.53554V7.53554Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path59"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11379 0.568239L6.89821 0.705422L11.9936 6.62384L12.2091 6.50626L7.11379 0.568239V0.568239ZM13.189 7.66251L12.9734 7.7801L16.7361 12.1699V11.7976L13.189 7.66251V7.66251Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path61"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.93725 0.665039L6.72168 0.782625L11.817 6.72064L12.0326 6.60306L6.93725 0.665039V0.665039ZM13.0124 7.75931L12.7969 7.8769L16.736 12.4823V12.0903L13.0124 7.75931Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path63"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.76147 0.762695L6.5459 0.880281L11.6412 6.83789L11.8568 6.70071L6.76147 0.762695ZM12.8367 7.85697L12.6211 7.97455L16.7366 12.7759V12.4036L12.8367 7.85697Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path65"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58471 0.864258L6.36914 0.981841L11.4645 6.93946L11.6801 6.80227L6.58471 0.864258ZM12.6599 7.95853L12.4443 8.07612L16.7362 13.0734V12.7011L12.6599 7.95853Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path67"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40893 0.962891L6.19336 1.08048L11.2887 7.03809L11.5043 6.90091L6.40893 0.962891V0.962891ZM12.4841 8.05717L12.2686 8.17475L16.7368 13.3877V12.9957L12.4841 8.05717V8.05717Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path69"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23197 1.05951L6.0164 1.17709L11.1117 7.13471L11.3273 6.99753L6.23197 1.05951ZM12.3268 8.15378L12.1112 8.27137L16.7362 13.6802V13.3079L12.3268 8.15378V8.15378Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path71"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05548 1.13574L5.82031 1.25333L10.9548 7.23054L11.1704 7.09336L6.05548 1.13574V1.13574ZM12.1503 8.24961L11.9347 8.3672L16.7361 13.9721V13.5997L12.1503 8.24961V8.24961Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path73"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.87873 1.22949L5.64355 1.34708L10.7977 7.34389C10.8173 7.3047 10.8369 7.2851 10.8761 7.2655L10.9937 7.18711L5.87873 1.22949L5.87873 1.22949ZM11.9735 8.34337L11.758 8.46095L16.6965 14.2226C16.7161 14.1638 16.7357 14.105 16.7357 14.0462V13.8894L11.9735 8.34337H11.9735Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70281 1.33128L5.46764 1.44886L10.7394 7.58286V7.50447C10.7394 7.44568 10.7785 7.36729 10.8178 7.30849L5.70281 1.33128ZM11.7976 8.44515L11.6408 8.54314C11.6212 8.54314 11.6017 8.56274 11.5821 8.56274L16.599 14.4224C16.6578 14.344 16.697 14.2656 16.7166 14.1872L11.7976 8.44515V8.44515Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path77"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.52616 1.43164L5.29102 1.54923L10.7391 7.8988V7.50684L5.52616 1.43164V1.43164ZM11.2486 8.46713L16.4615 14.5619C16.5203 14.5227 16.5791 14.4443 16.6379 14.3855L11.621 8.54552C11.5426 8.58471 11.425 8.58471 11.3466 8.54552L11.2486 8.46713Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path79"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.35038 1.53027L5.11523 1.64786L16.2857 14.6606L16.4425 14.5822C16.4621 14.5626 16.4817 14.543 16.5013 14.5234L11.3668 8.54616H11.3472L10.8965 8.27179C10.8573 8.2522 10.8377 8.213 10.7985 8.17381C10.7593 8.11501 10.7593 8.07582 10.7397 8.03662V7.82105L5.35038 1.53027V1.53027Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path81"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17353 1.62775L4.93836 1.74533L16.1089 14.758L16.3244 14.6404L5.17353 1.62775Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path83"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99689 1.7041L4.76172 1.82169L15.9518 14.854L16.1674 14.7364L4.99689 1.7041Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path85"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82099 1.80544L4.58582 1.92303L15.776 14.9553L15.9915 14.8377L4.82099 1.80544Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path87"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64435 1.90234L4.40918 2.01993L15.5993 15.0522L15.8149 14.9346L4.64435 1.90234Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path89"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.448 2L4.23242 2.11759L15.4226 15.1695L15.6381 15.0323L4.448 2Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path91"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.27221 2.09766L4.05664 2.21524L15.2468 15.2671L15.4623 15.1299L4.27221 2.09766Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path93"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.09643 2.19629L3.88086 2.31387L15.0906 15.3658L15.3062 15.2286L4.09643 2.19629Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path95"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.91967 2.27441L3.7041 2.392L14.9138 15.4635L15.1294 15.3263L3.91967 2.27441Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path97"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74292 2.37305L3.52734 2.49063L14.7371 15.5621L14.9526 15.4445L3.74292 2.37305Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path99"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.56616 2.4707L3.35059 2.58829L8.79868 8.93784L8.97504 9.05543C9.05343 9.09462 9.13182 9.19261 9.13182 9.2906V9.3102L14.5603 15.6598L14.7759 15.5422L3.56616 2.4707Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path101"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3903 2.56848L3.17473 2.68606L8.28967 8.66329L8.93636 9.01602L3.3903 2.56848ZM9.11274 9.23159C9.11274 9.25119 9.13234 9.27079 9.13234 9.29038V9.62354L14.3845 15.7576L14.6 15.64L9.11274 9.23159V9.23159Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path103"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.21362 2.66504L2.99805 2.78262L7.77983 8.3679L8.42655 8.72066L3.21362 2.66504V2.66504ZM9.13203 9.54373V9.91609L14.2274 15.8541L14.4429 15.7365L9.13203 9.54373V9.54373Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path105"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.03784 2.76367L2.82227 2.88126L7.29049 8.07459L7.91761 8.42734L3.03784 2.76367V2.76367ZM9.13263 9.83834V10.2303L14.0516 15.9527L14.2672 15.8352L9.13263 9.83834V9.83834Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path107"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.86108 2.84277L2.64551 2.96036L6.78057 7.78134L7.40769 8.15369L2.86108 2.84277ZM9.13225 10.1526V10.525L13.8748 16.0514L14.0904 15.9338L9.13225 10.1526V10.1526Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path109"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68432 2.94141L2.46875 3.05899L6.27064 7.48802L6.89777 7.86037L2.68432 2.94141V2.94141ZM9.13186 10.4472V10.8196L13.6981 16.1501L13.9136 16.0325L9.13186 10.4472V10.4472Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path111"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50848 3.03884L2.29291 3.15643L5.76164 7.2131L6.38877 7.56586L2.50848 3.03884ZM9.1324 10.7406V11.1326L13.5222 16.2671L13.7378 16.1299L9.1324 10.7406V10.7406Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path113"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33178 3.13574L2.11621 3.25333L5.25181 6.91805L5.87891 7.2708L2.33178 3.13574V3.13574ZM9.13208 11.0531V11.4255L13.3651 16.364L13.5807 16.2268L9.13208 11.0531V11.0531Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path115"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15502 3.2334L1.93945 3.35098L4.74189 6.62375L5.38859 6.97651L2.15502 3.2334V3.2334ZM9.1317 11.3467V11.7191L13.1884 16.4617L13.4039 16.3245L9.1317 11.3467Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path117"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.97924 3.32422L1.76367 3.4418L4.23295 6.32262L4.87967 6.69497L1.97924 3.32422V3.32422ZM7.11377 9.67378L7.62331 10.2617V10.0461C7.62331 10.0069 7.58411 9.94814 7.54491 9.92855L7.11377 9.67378V9.67378ZM9.13229 11.6335V12.0255L13.0126 16.5525L13.2282 16.4153L9.13229 11.6335V11.6335Z"
        fill="var(--fill-0, #DB0032)"
      />
      <path
        id="path119"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.80248 3.41113L1.58691 3.52872L3.72303 6.03718L4.36975 6.40953L1.80248 3.41113V3.41113ZM6.60385 9.38834L7.62292 10.5642V10.1918L7.25057 9.76069L6.60385 9.38834V9.38834ZM9.13191 11.9556V12.328L12.8358 16.659L13.0514 16.5414L9.13191 11.9556V11.9556Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path121"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6267 3.50781L1.41113 3.6254L3.23369 5.76151L3.86081 6.11426L1.6267 3.50781V3.50781ZM6.09491 9.11267L7.62352 10.8764V10.5041L6.74163 9.46542L6.09491 9.11267ZM9.13251 12.2483V12.6206L12.66 16.7557L12.8756 16.6381L9.13251 12.2483Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path123"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44995 3.60645L1.23438 3.72403L2.72377 5.46819L3.35089 5.82094L1.44995 3.60645V3.60645ZM5.60459 8.81937L7.62314 11.1711V10.7987L6.23171 9.1721L5.60459 8.81937ZM9.13212 12.5625V12.9348L12.5029 16.8543L12.7185 16.7367L9.13212 12.5625V12.5625Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path125"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.27319 3.69629L1.05762 3.81387L2.21387 5.16611L2.84098 5.51884L1.27319 3.69629V3.69629ZM5.0947 8.51727L7.62276 11.4569V11.0845L5.72179 8.88959L5.0947 8.51727ZM9.13175 12.8483V13.2206L12.3261 16.9441L12.5417 16.8266L9.13175 12.8483V12.8483Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path127"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09739 3.80188L0.881816 3.91947L1.70491 4.87975L2.33202 5.2521L1.09739 3.80188ZM4.58574 8.23091L7.62333 11.778V11.4057L5.21286 8.60326L4.58574 8.23091ZM9.13232 13.1498V13.5222L12.1503 17.0497L12.3659 16.9321L9.13232 13.1498V13.1498Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path129"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.920649 3.89941L0.705078 4.017L1.19501 4.58533L1.84173 4.95768L0.920649 3.89941V3.89941ZM4.07584 7.95608L7.62297 12.0715V11.6992L4.70296 8.30884L4.07584 7.95608ZM9.13196 13.4629V13.8353L11.9736 17.1473L12.1892 17.0297L9.13196 13.4629V13.4629Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path131"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.744968 3.97862L0.5098 4.09621L0.686175 4.31178L1.33289 4.66454L0.744968 3.97862ZM3.567 7.66294L7.62367 12.3859V11.994L4.21372 8.0157L3.567 7.66294ZM9.13265 13.7577V14.1301L11.7979 17.2657L12.0135 17.1285L9.13265 13.7577Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path133"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.568821 4.06934L0.431641 4.14773L0.823589 4.3633L0.568821 4.06934V4.06934ZM3.05769 7.3617L7.6239 12.6726V12.3003L3.70441 7.73406L3.05769 7.3617V7.3617ZM9.13289 14.0444V14.4364L11.6414 17.3564L11.8569 17.2192L9.13289 14.0444V14.0444Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path135"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.56641 7.07129L7.62255 12.9701V12.5978L3.19352 7.44364L2.56641 7.07129ZM9.13153 14.3615V14.7339L11.4636 17.4579L11.6792 17.3207L9.13153 14.3615V14.3615Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path137"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.05773 6.79986L7.6234 13.2866V12.8947L2.68484 7.15262L2.05773 6.79986V6.79986ZM9.13239 14.6584V15.0308L11.2881 17.5589L11.5037 17.4217L9.13239 14.6584V14.6584Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path139"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54883 6.50684L7.62403 13.5815V13.2092L2.17595 6.85959L1.54883 6.50684V6.50684ZM9.13302 14.9533V15.3453L11.1124 17.6578L11.3279 17.5402L9.13302 14.9533Z"
        fill="var(--fill-0, #DC0032)"
      />
      <path
        id="path141"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.03906 6.21484L7.6238 13.8774V13.5051L1.66618 6.5872L1.03906 6.21484ZM9.13279 15.2689V15.6412L10.9358 17.7577L11.1513 17.6401L9.13279 15.2689V15.2689Z"
        fill="var(--fill-0, #DB0032)"
      />
      <path
        id="path143"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.529279 5.91805L7.62355 14.1882V13.8158L1.1564 6.2904L0.529279 5.91805ZM9.13254 15.56V15.9323L10.7787 17.8529L10.9943 17.7353L9.13254 15.56V15.56Z"
        fill="var(--fill-0, #DA0032)"
      />
      <path
        id="path145"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0194798 5.63963L7.62328 14.4781V14.1057L0.666195 5.99239L0.0194798 5.63963V5.63963ZM9.13227 15.8499V16.2418L10.6021 17.9468L10.8177 17.8292L9.13227 15.8499Z"
        fill="var(--fill-0, #D90032)"
      />
      <path
        id="path147"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.62402V5.89839L7.6234 14.776V14.4037L0.15678 5.70241L0 5.62402ZM9.13239 16.1674V16.4026C9.13239 16.4418 9.11279 16.481 9.0932 16.5006L10.4258 18.0488L10.6414 17.9312L9.13239 16.1674V16.1674Z"
        fill="var(--fill-0, #D80032)"
      />
      <path
        id="path149"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.82017V6.21212L7.6234 15.0898V14.7174L0 5.82017ZM9.11279 16.4616C9.09319 16.54 9.0344 16.6184 8.97561 16.638L8.95601 16.6576L10.2494 18.147L10.465 18.0294L9.11279 16.4616L9.11279 16.4616Z"
        fill="var(--fill-0, #D70032)"
      />
      <path
        id="path151"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.1347V6.50705L7.6234 15.3847V15.0123L0 6.1347ZM8.99521 16.6193C8.99521 16.6389 8.99521 16.6389 8.97561 16.6389L8.77966 16.7565L10.0731 18.2459L10.2886 18.1283L8.99521 16.6193L8.99521 16.6193Z"
        fill="var(--fill-0, #D60032)"
      />
      <path
        id="path153"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.42773V6.80009L7.6234 15.6777V15.3054L0 6.42773ZM8.83842 16.7164L8.60328 16.8536L9.91629 18.3626L10.1319 18.2254L8.83842 16.7164Z"
        fill="var(--fill-0, #D50032)"
      />
      <path
        id="path155"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.74316V7.11552L7.6234 15.9931V15.6208L0 6.74316ZM8.66207 16.8162L8.52489 16.8946C8.4857 16.9142 8.4465 16.9142 8.40731 16.9142L9.73991 18.4624L9.95549 18.3253L8.66207 16.8162V16.8162Z"
        fill="var(--fill-0, #D40032)"
      />
      <path
        id="path157"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.03516V7.40751L7.6234 16.2851V15.9128L0 7.03516ZM8.05455 16.8143L9.56354 18.5584L9.77911 18.4213L8.4661 16.9123C8.4465 16.9123 8.4073 16.9319 8.38771 16.9319H8.36811C8.30932 16.9319 8.27012 16.9123 8.23093 16.8927L8.05455 16.8143L8.05455 16.8143Z"
        fill="var(--fill-0, #D30032)"
      />
      <path
        id="path159"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.33199V7.72394L9.38716 18.6593L9.60273 18.5221L8.19173 16.8759L7.76059 16.6408C7.68219 16.6016 7.6234 16.5036 7.6234 16.4056V16.2096L0 7.33199Z"
        fill="var(--fill-0, #D20032)"
      />
      <path
        id="path161"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.64272V8.01507L9.21078 18.7545L9.42635 18.6369L0 7.64272Z"
        fill="var(--fill-0, #D10032)"
      />
      <path
        id="path163"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.94043V8.31278L9.0344 18.8562L9.24998 18.7386L0 7.94043Z"
        fill="var(--fill-0, #D00032)"
      />
      <path
        id="path165"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.23242V8.62437L8.87762 18.9522L9.09319 18.8346L0 8.23242Z"
        fill="var(--fill-0, #CF0032)"
      />
      <path
        id="path167"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.54688V8.9192L8.70127 19.0511L8.91682 18.9335L0 8.54688Z"
        fill="var(--fill-0, #CE0032)"
      />
      <path
        id="path169"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.84001V9.21237L8.50529 19.1287C8.56409 19.1091 8.62288 19.0895 8.68167 19.0699L8.74046 19.0307L0 8.84001Z"
        fill="var(--fill-0, #CD0032)"
      />
      <path
        id="path171"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.13363V9.52559L8.25052 19.1283C8.28972 19.1283 8.32891 19.1283 8.36811 19.1283C8.4269 19.1283 8.4857 19.1283 8.54449 19.1087L0 9.13363Z"
        fill="var(--fill-0, #CC0032)"
      />
      <path
        id="path173"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.44816V9.82051L7.79978 18.9137L8.07415 19.0705C8.13294 19.1097 8.23093 19.1293 8.30932 19.1293L0 9.44816Z"
        fill="var(--fill-0, #CB0032)"
      />
      <path
        id="path175"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.74121V10.1136L7.29024 18.6189L7.93696 18.9912L0 9.74121Z"
        fill="var(--fill-0, #CA0032)"
      />
      <path
        id="path177"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.0525V10.4249L6.78071 18.3226L7.42743 18.695L0 10.0525Z"
        fill="var(--fill-0, #C90032)"
      />
      <path
        id="path179"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.3447V10.7171L6.27117 18.0269L6.89829 18.3993L0 10.3447Z"
        fill="var(--fill-0, #C80033)"
      />
      <path
        id="path181"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.6417V11.014L5.76163 17.7359L6.38876 18.1083L0 10.6417Z"
        fill="var(--fill-0, #C70033)"
      />
      <path
        id="path183"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.9492V11.3216L5.23252 17.4164L5.87922 17.7887L0 10.9492Z"
        fill="var(--fill-0, #C60033)"
      />
      <path
        id="path185"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.246V11.6184L4.72299 17.1252L5.36968 17.4976L0 11.246Z"
        fill="var(--fill-0, #C50033)"
      />
      <path
        id="path187"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.542V11.9143L4.21345 16.8333L4.86017 17.2056L0 11.542V11.542Z"
        fill="var(--fill-0, #C40033)"
      />
      <path
        id="path189"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.8494V12.2218L3.70391 16.5332L4.35063 16.9055L0 11.8494Z"
        fill="var(--fill-0, #C30033)"
      />
      <path
        id="path191"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.1465V12.5188L3.19438 16.2423L3.8411 16.6147L0 12.1465Z"
        fill="var(--fill-0, #C20033)"
      />
      <path
        id="path193"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.4433V12.8352L2.68484 15.9512L3.31196 16.3236L0 12.4433Z"
        fill="var(--fill-0, #C10033)"
      />
      <path
        id="path195"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.7578V13.1302L2.15572 15.6583L2.80243 16.0306L0 12.7578Z"
        fill="var(--fill-0, #C00033)"
      />
      <path
        id="path197"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.0467V13.419L1.64618 15.3592L2.2929 15.712L0 13.0467Z"
        fill="var(--fill-0, #BF0033)"
      />
      <path
        id="path199"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.3398V13.7318L1.13665 15.0448L1.78337 15.4172L0 13.3398Z"
        fill="var(--fill-0, #BE0033)"
      />
      <path
        id="path201"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.6582V14.0306L0.627117 14.7557L1.27383 15.128L0 13.6582Z"
        fill="var(--fill-0, #BD0033)"
      />
      <path
        id="path203"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.9473V14.0453C0 14.2412 0.137182 14.4764 0.293961 14.5744L0.7643 14.8292L0 13.9473V13.9473Z"
        fill="var(--fill-0, #BC0033)"
      />
      <path
        id="path205"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.117188 14.3994C0.156382 14.4386 0.17598 14.4778 0.215175 14.4974L0.117188 14.3994Z"
        fill="var(--fill-0, #BB0033)"
      />
    </g>
  </svg>
)
export {DeliveryDpdIcon}
